import useConfig from 'client/hooks/useConfig';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import H5HeaderLayout from './layouts/H5HeaderLayout';
import HeaderLayout from './layouts/HeaderLayout';
import ModelsPage from './pages/ModelsPage';
import OptionsPage from './pages/OptionsPage';
import Router from './Router';
import { ENABLE_NEW_COMING_SOON } from 'client/settings';
import ComingSoonRedirectMessage from 'client/components/ComingSoonRedirectMessage';

export default function Main() {
  const { APPONLY } = useConfig();
  const NewHeaderLayout = APPONLY === '1' ? H5HeaderLayout : HeaderLayout;
  return (
    <NewHeaderLayout>
      {
        ENABLE_NEW_COMING_SOON ?
          <Switch>
            <Route path="/:region(us|cn)/:entry(configurator|design)">
              <ComingSoonRedirectMessage isApp={APPONLY === '1'} />
            </Route>
          </Switch> :
          <Router
            models={ModelsPage}
            options={OptionsPage}
          />
      }
    </NewHeaderLayout>
  );
}
